export enum EnmApplicationAvailabilityStatus {
    None = 0,
    Error = 5,
    Available = 1001,
    Beta = 1002,
    EarlyAccess = 1003,
    LimitedAvailability = 1004,
    InviteOnly = 1005,
    ComingSoon = 2001,
    Scheduled = 2002,
    TemporarilyUnavailable = 3001,
    Maintenance = 3002,
    Unavailable = 3003,
    Private = 4001,
    Suspended = 4002,
    Deprecated = 5001,
    Discontinued = 5002,
    Archived = 5003
}